export default "__VITE_ASSET__6da92dc2__"